import { RegexBasedPasswordPolicy } from './RegexBasedPasswordPolicy';

export class MustContainUppercaseLettersPolicy extends RegexBasedPasswordPolicy {

    private static instance: MustContainUppercaseLettersPolicy = new MustContainUppercaseLettersPolicy();

    private constructor() {
        super(/[A-Z]/);
    }

    public static getPolicy(): MustContainUppercaseLettersPolicy {
        return MustContainUppercaseLettersPolicy.instance;
    }
}
